import { AsyncQueries, AsyncQueriesParams } from "../base";
import { AltiusRes, IRRGraph, IRRGraphPayload, LiquidityGraph, LiquidityGraphPayload } from "../../../store/types";
import { convertDateRange } from "../../../utils";

export interface IGeneralQueries {
  getLiquidityGraph: (queries: LiquidityGraphPayload) => Promise<LiquidityGraph>;
  getIRRGraph: (queries: IRRGraphPayload) => Promise<IRRGraph>;
}

export class GeneralQueries extends AsyncQueries implements IGeneralQueries {
  public constructor(params: AsyncQueriesParams) {
    super(params);
  }

  public getLiquidityGraph = async ({ filters, dateRange, exchangeMethod, currency }: LiquidityGraphPayload) => {
    const {
      data: { data: graph }
    } = await this.api.post<AltiusRes<LiquidityGraph>>({
      url: "/api/v0.0.3/reports/get-cashflow-graph",
      data: {
        filters,
        currency,
        dateRange: convertDateRange(dateRange),
        exchangeDate: exchangeMethod
      }
    });

    return graph;
  };

  public getIRRGraph = async ({ filters, dateRange, measureId, use_accounting_date }: IRRGraphPayload) => {
    const {
      data: { data: graph }
    } = await this.api.post<AltiusRes<IRRGraph>>({
      url: "/api/v0.0.3/reports/fetch-irr-graph",
      data: {
        filters,
        dateRange: convertDateRange(dateRange),
        measureId,
        use_accounting_date
      }
    });

    return graph;
  };
}
